@if (count() > 1) {
  <div class="countdown-bar__pagination">
    @for (dot of dots(); track dot) {
      <button
        [class.is-active]="dot === activeIndex()"
        type="button"
        class="countdown-bar__dot"
        aria-label="Select game"
        (click)="selectIndex.emit(dot)"
      ></button>
    }
  </div>
}
